import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-privacy-policy-ios',
    templateUrl: './privacy-policy-ios.component.html',
    styleUrls: ['./privacy-policy-ios.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class PrivacyPolicyIosComponent {
    constructor(title: Title) {
        title.setTitle('Datenschutzerklärung für iOS | Mondkalender Moony');
    }
}
